import { OptionsType } from '@openx/types/options';
import { produceSortedOptionsKeys } from '@openx/utils/lib/sortedOptions';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export function useSelectRateOptionsFetch(
  optionType: typeof OptionsType.VIEWABILITY | typeof OptionsType.VIEW_THROUGH_RATE
) {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: {
      path:
        optionType === OptionsType.VIEWABILITY
          ? 'deal.package.targeting.viewability.viewability_score'
          : 'deal.package.targeting.vtr.vtr_score',
    },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [];
    }

    return optionsByPath.map(option =>
      option
        ? {
            id: option.id,
            name: option.name,
            ...option.extra,
          }
        : []
    );
  }, [optionsByPath]);

  const mapById = useMemo(() => {
    return list
      .map(option => ({ [option.id]: option }))
      .reduce((acc, curr) => {
        return Object.assign(acc, curr);
      }, {});
  }, [list]);

  const optionsList = useMemo(() => produceSortedOptionsKeys(mapById), [mapById]);

  return {
    isSelectRateLoading: loading,
    optionsList,
    selectRate: mapById,
  };
}
